import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {ImportRecordButton} from "../buttons/ImportRecordButton.tsx";
import config from "../config";


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes('DeletePlaybook')) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes('CreatePlaybook')) {
        // FNP-1011: import creates a playbook, so it is gated on the same
        // action as Add rather than a new Cedar action. A new action would need
        // the Verified Permissions policy updated in lockstep — and until it
        // was, the button would render for nobody.
        tools.push(<ImportRecordButton key='import'/>);
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
